import React, { useEffect, useState } from 'react';

import { showErrorToast } from 'components/Toast';

import { checkFileType, validateFile } from 'utils/fileUtils';
import { REQUIRED_RULE } from 'utils/constants';
import { useUbigeo } from 'hooks/useUbigeo';

export default function SignupStepCompany({
  buildBaseInput,
  setValue,
  watch,
  generalApi,
  documentFile,
  setDocumentFile,
}: {
  buildBaseInput: any;
  setValue: any;
  watch: any;
  generalApi: any;
  documentFile: any;
  setDocumentFile: any;
}) {
  const department = watch('department');
  const province = watch('province');

  const [imagePreview, setImagePreview] = useState<string | ArrayBuffer | null | undefined>(null);

  const [departments, provinces, districts] = useUbigeo(false, generalApi, department, province);

  useEffect(() => {
    setValue('province', provinces[0]);
  }, [provinces, setValue]);

  useEffect(() => {
    setValue('district', districts[0]);
  }, [districts, setValue]);

  const checkFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let isValid = validateFile(event.target, 'document');
    if (!isValid || !event.target?.files) {
      setDocumentFile(null);
      showErrorToast('Formato de documento no válido, debe ser un archivo .png, .jpg o .jpeg');
      return;
    }
    setDocumentFile(event.target.files[0]);
    if (checkFileType(event.target.files[0].name) === 'image') {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        setImagePreview(e?.target?.result);
      };
      await reader.readAsDataURL(event.target.files[0]);
    }
  };

  useEffect(() => {
    if (documentFile) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        setImagePreview(e?.target?.result);
      };
      reader.readAsDataURL(documentFile);
    }
  }, [documentFile]);

  return (
    <div className="grid grid-cols-3 gap-6 px-8 pt-8 pb-8">
      {buildBaseInput('Razón social *', 'text', 'commercial_name', REQUIRED_RULE, {})}
      {buildBaseInput('Actividad económica *', 'text', 'economic_activity', REQUIRED_RULE, {})}
      {buildBaseInput('Dirección comercial *', 'text', 'commercial_address', REQUIRED_RULE, {})}
      {buildBaseInput('Región *', 'select', 'department', REQUIRED_RULE, {
        options: departments.map((obj) => ({
          name: obj,
        })),
      })}
      {buildBaseInput('Provincia *', 'select', 'province', REQUIRED_RULE, {
        options: provinces.map((obj) => ({
          name: obj,
        })),
      })}
      {buildBaseInput('Distrito *', 'select', 'district', REQUIRED_RULE, {
        options: districts.map((obj) => ({
          name: obj,
        })),
      })}
      {buildBaseInput('Celular *', 'text', 'cellphone', REQUIRED_RULE, {})}
      {buildBaseInput(
        'Teléfono',
        'text',
        'telephone',
        {},
        {
          helperText: '0 + Código de Ciudad + Número Telefónico',
        }
      )}
      {buildBaseInput('Correo electrónico *', 'email', 'email', REQUIRED_RULE, {})}
      <div />
      <div className="relative mx-auto w-full rounded-md border-2 border-dashed border-gray-300 px-2 py-4 text-center">
        <p className="mb-4">Adjuntar ficha RUC (*)</p>
        <div className="flex flex-col items-center justify-evenly sm:flex-row sm:space-y-0">
          <div className="flex items-center space-x-2 text-center">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="text-sm text-gray-600">
              <label
                htmlFor="inp_document_file"
                className="relative mx-auto cursor-pointer rounded-md bg-white font-medium text-primary-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2 hover:text-primary-500"
              >
                <span>{documentFile ? 'Cambiar archivo' : 'Escoger archivo'}</span>
                <input
                  id="inp_document_file"
                  name="inp_document_file"
                  type="file"
                  className="sr-only"
                  accept=".png, .jpg, .jpeg"
                  onChange={checkFile}
                />
              </label>
              <p className="max-w-[120px] text-xs text-gray-500">imagen hasta 10MB</p>
            </div>
          </div>
          {documentFile && imagePreview && (
            <img
              src={imagePreview as string}
              className="max-h-64 max-w-full rounded-lg border-2 border-primary-200 sm:max-w-[50%]"
              alt="Imagen del documento"
            ></img>
          )}
        </div>
      </div>
    </div>
  );
}
